import { render, staticRenderFns } from "./PagePopup.vue?vue&type=template&id=e562004a"
import script from "./PagePopup.vue?vue&type=script&lang=js"
export * from "./PagePopup.vue?vue&type=script&lang=js"
import style0 from "./PagePopup.vue?vue&type=style&index=0&id=e562004a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports